import {
  FeatureName,
  useCurrentWorkspace,
  useIsFeatureEnabled,
} from '@gripp/shared-logic';
import { SlideAction, useSlideLayout } from '@gripp/shared-ui';
import { useWorkspaceAsset } from 'libs/shared-logic/src/assets/hooks/useWorkspaceAsset';
import { Icon } from 'libs/shared-ui/src/components/crop-circle/icons/Icon';
import { useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { useLocation, useNavigate } from 'react-router';
import { NewIssueModalProps } from '../../issues';
import { AddButton } from '../../shared/components/addButton/addButton';
import { useAssetRouting } from '../assetRouteContext';
import { isActivityOrEditPage } from '../assetUtils';
import { AssetFiltersOld } from './assetFilters-old';

export const AssetFilters = ({ assetId }: { assetId: string }) => {
  // TODO: Crop Circle Redesign: Remove after feature is fully rolled out
  const isCropCircleEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );
  const { workspaceAsset } = useWorkspaceAsset(assetId, !assetId);
  const workspaceId = workspaceAsset?.workspace?.id ?? '';

  if (!assetId) {
    return null;
  }

  // TODO: Crop Circle Redesign: Remove after feature is fully rolled out
  if (!isCropCircleEnabled) {
    return <AssetFiltersOld assetId={assetId} workspaceId={workspaceId} />;
  }

  // TODO: Crop Circle Redesign: Remove to AssetFiltersBase after feature is fully rolled out
  return <AssetFiltersBase assetId={assetId} workspaceId={workspaceId} />;
};

export const AssetFiltersBase = ({
  assetId,
  workspaceId,
}: {
  assetId: string;
  workspaceId: string;
}) => {
  const [issueModalVisible, setIssueModalVisible] = useState(false);
  const [newIssueModalProps, setNewIssueModalProps] = useState<
    NewIssueModalProps | undefined
  >(undefined);
  const { onSlideChange } = useSlideLayout();
  const location = useLocation();
  const navigate = useNavigate();
  const { basePath, isWorkspaceMode } = useAssetRouting(assetId);
  const workspace = useCurrentWorkspace();

  const onIssueComplete = () => {
    setIssueModalVisible(false);
  };

  const onAssetEdit = async () => {
    const editPath = `${basePath}/edit`;

    // Skip NEXT on /assets/:id — edit is rendered inline so no transition.
    const isOnAssetDetail = /^\/assets\/[^/]+\/?$/.test(location.pathname);
    if (!isActivityOrEditPage(location) && !isOnAssetDetail) {
      await onSlideChange(SlideAction.NEXT);
    }

    navigate(editPath);
  };

  const onAddNewIssue = async () => {
    const newIssuePath = `${basePath}/activity/new`;

    if (!isActivityOrEditPage(location)) {
      await onSlideChange(SlideAction.NEXT);
    }

    navigate(newIssuePath);
  };

  return (
    <View style={styles.filtersContainer}>
      <Pressable onPress={onAssetEdit} testID="asset-card-edit-button">
        <Icon name="Settings" size={24} />
      </Pressable>
      {workspace && <AddButton onPress={onAddNewIssue} />}
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 16,
  },
  modal: {
    alignSelf: 'center',
    backgroundColor: 'white',
    padding: 0,
    margin: 0,
    borderRadius: 10,
    width: 560,
    minHeight: 400,
  },
});
